export const HEALTH_MESSAGES = {
  NO_DATA: "Not enough data to make considerations.",
  LOW: "Your heart rate is below normal. It may indicate fatigue, dehydration, or other conditions. Consider monitoring your symptoms.",
  AVG: "Your heart rate is within a healthy range. Keep maintaining your normal routine and lifestyle.",
  HIGH: "Your heart rate is elevated. This may be due to stress, activity, or other factors. Consider resting and monitoring how you feel.",
};
